"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateDelete_OnClick = exports.Template_OnClick = exports.OnSuccessGetAanvraagTemplates = exports.InitAlgemeneInfo = exports.chkBio = exports.tbAantalFotos = exports.tbLotNr = exports.tbPDFNaam = exports.cbPriority = exports.tbProducer = exports.Templates = exports.cbInvoiceCustomer = exports.cbControlNumber = exports.cbControlType = exports.cbProcessing = exports.cbProducer = exports.tbPriority = exports.tbControlNumber = exports.tbControlType = exports.tbProcessing = exports.tbInvoiceCustomer = exports.tbRemark = exports.tbBrix = exports.tbBrand = exports.tbExtraIdentification = exports.tbCustomerReference = exports.tbReference = exports.tbSequenceNumber = void 0;
var Algemeen = require("./Algemeen");
var Aanvraag = require("./Aanvraag");
var AanvraagStaal = require("./AanvraagStaal");
var SampleNature = require("./AanvraagAlgemeneInfo/SampleNature");
var Contact = require("./AanvraagAlgemeneInfo/Contact");
var Country = require("./AanvraagAlgemeneInfo/Country");
var Methodes = require("./AanvraagMethodes/Methodes");
var AanvraagReports = require("./AanvraagReports");
var ComboboxNew = require("./ComboboxNew");
var templateCodeToDelete;
var $dialogTemplateDelete;
function InitAlgemeneInfo(Defaults) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            document.addEventListener('focusin', function () {
                console.log('focused: ', document.activeElement);
            }, true);
            /*
            Get default value for fields
            */
            $("#dialogTemplates").dialog({
                autoOpen: false,
                modal: false,
                width: 300,
                title: Algemeen.Translate('nmTemplates'),
                position: { my: "right top", at: "right top", of: "#tabs" },
                close: function (event, ui) { $(".btnTemplate").show(); },
                open: function (event, ui) { $(".btnTemplate").hide(); },
                create: function (event, ui) {
                    var $dialog = $(this);
                    var $title = $(this).dialog("widget").find("span.ui-dialog-title");
                    var $img = $("<img />");
                    $img.attr('src', 'Images/Information-icon.png');
                    $img.attr('class', 'infoImage infoImageDialogTitle');
                    $img.attr('id', 'infoImageTemplate');
                    //$img.click(function () { InfoImageClick(this, $("#dialogTemplatesToolTip"), $dialog); });
                    $img.hover(function (event) { Algemeen.showPopUp($img.attr('id'), $("#dialogTemplatesToolTip").html().trim(), event); }, function (event) { Algemeen.hidePopUp($img.attr('id'), event); });
                    $title.append($img);
                }
            });
            SampleNature.InitSampleNature(true);
            //OnSuccessGetCustomerDefaults(result);
            Contact.InitContact();
            Country.InitCountry();
            exports.tbProducer = $('#ctl00_cphBody_tbProducer');
            exports.cbProducer = new ComboboxNew.ComboBoxNew(exports.tbProducer, 'divDropDownItem', 'divDropDownItemInFocus', 'GetProducers', true, true, undefined);
            if (Aanvraag.EditMode) {
                exports.cbProducer.InitSelectedText = Aanvraag.AanvraagObj.Producer;
            }
            exports.cbProducer.Init();
            exports.tbInvoiceCustomer = $('#ctl00_cphBody_tbInvoiceCustomer');
            exports.cbInvoiceCustomer = new ComboboxNew.ComboBoxNew(exports.tbInvoiceCustomer, 'divDropDownItem', 'divDropDownItemInFocus', 'GetInvoiceCustomers', false, false, ((Aanvraag.EditMode) ? Aanvraag.AanvraagObj.InvoiceCustomer : Defaults.CustomerInvoice.number));
            exports.cbInvoiceCustomer.Init();
            exports.tbProcessing = $('#ctl00_cphBody_tbProcessing');
            exports.cbProcessing = new ComboboxNew.ComboBoxNew(exports.tbProcessing, 'divDropDownItem', 'divDropDownItemInFocus', 'GetProcessings', false, true, ((Aanvraag.EditMode) ? Aanvraag.AanvraagObj.Processing : undefined));
            exports.cbProcessing.Init();
            exports.tbControlType = $('#ctl00_cphBody_tbControlType');
            exports.cbControlType = new ComboboxNew.ComboBoxNew(exports.tbControlType, 'divDropDownItem', 'divDropDownItemInFocus', 'GetControlTypes', false, true, ((Aanvraag.EditMode) ? Aanvraag.AanvraagObj.ControlType : undefined));
            exports.cbControlType.Init();
            exports.tbControlNumber = $('#ctl00_cphBody_tbControlNumber');
            exports.cbControlNumber = new ComboboxNew.ComboBoxNew(exports.tbControlNumber, 'divDropDownItem', 'divDropDownItemInFocus', 'GetControlNumbers', false, true, ((Aanvraag.EditMode) ? Aanvraag.AanvraagObj.ControlNumber : undefined));
            exports.cbControlNumber.Init();
            exports.tbPriority = $('#ctl00_cphBody_tbPriority');
            exports.cbPriority = new ComboboxNew.ComboBoxNew(exports.tbPriority, 'divDropDownItem', 'divDropDownItemInFocus', 'GetPriorities', false, true, ((Aanvraag.EditMode) ? Aanvraag.AanvraagObj.Priority : undefined));
            exports.cbPriority.Init();
            exports.tbSequenceNumber = $('#ctl00_cphBody_tbSequenceNumber');
            Algemeen.DisableEnterKey(exports.tbSequenceNumber);
            exports.tbReference = $('#ctl00_cphBody_tbReference');
            Algemeen.DisableEnterKey(exports.tbReference);
            exports.tbCustomerReference = $('#ctl00_cphBody_tbCustomerReference');
            Algemeen.DisableEnterKey(exports.tbCustomerReference);
            exports.tbExtraIdentification = $('#ctl00_cphBody_tbExtraIdentification');
            Algemeen.DisableEnterKey(exports.tbExtraIdentification);
            exports.tbBrand = $('#ctl00_cphBody_tbBrand');
            Algemeen.DisableEnterKey(exports.tbBrand);
            exports.tbBrix = $('#ctl00_cphBody_tbBrix');
            Algemeen.DisableEnterKey(exports.tbBrix);
            exports.tbRemark = $('#ctl00_cphBody_tbRemark');
            Algemeen.DisableEnterKey(exports.tbRemark);
            exports.tbPDFNaam = $('#ctl00_cphBody_tbPDFNaam');
            Algemeen.DisableEnterKey(exports.tbPDFNaam);
            exports.tbLotNr = $('#ctl00_cphBody_tbLotNr');
            Algemeen.DisableEnterKey(exports.tbLotNr);
            exports.tbAantalFotos = $('#ctl00_cphBody_tbAantalFotos');
            exports.chkBio = $('#chkBio');
            Algemeen.DisableEnterKey(exports.tbAantalFotos);
            $dialogTemplateDelete = $('#dialogTemplateDelete');
            $dialogTemplateDelete.dialog({
                autoOpen: false,
                modal: true,
                width: 400,
                buttons: [
                    {
                        text: Algemeen.Translate('nmJa'),
                        click: function () { TemplateDelete(null); }
                    },
                    {
                        text: Algemeen.Translate('nmNee'),
                        click: function () { $(this).dialog("close"); }
                    }
                ]
            });
            return [2 /*return*/];
        });
    });
}
exports.InitAlgemeneInfo = InitAlgemeneInfo;
function OnSuccessGetAanvraagTemplates(data, status) {
    Algemeen.CheckSessionTimeout(data);
    exports.Templates = data.d;
    if (exports.Templates.length > 0) {
        var $tableTemplates = $('#tableTemplates');
        $tableTemplates.empty();
        for (var i = 0; i < exports.Templates.length; i++) {
            var Template = exports.Templates[i];
            var imgDelete = '<img onclick="EntryPoint.TemplateDelete_OnClick(&quot;' + Template.Code + '&quot;)" src="Images/cross-script-icon.png"/>';
            var $tr = $('<tr class="trTemplate trItem ' + Algemeen.GetTrClass(i) + '"><td class="tdTemplateName" onclick="EntryPoint.Template_OnClick(&quot;' + Template.Code + '&quot;)">' + Template.Description + '</td><td>' + imgDelete + '</td></tr>');
            $tableTemplates.append($tr);
        }
        $("#dialogTemplates").dialog({
            position: { my: "right top", at: "right top", of: "#tabs" },
            maxHeight: $('#tabs').height(),
            width: 315
        });
        //$("#dialogTemplates").dialog( 'option', 'position', { my: "right top", at: "right top", of: "#tabs" });
        //$("#dialogTemplates").dialog('option', 'maxHeight', '500px');
        $("#dialogTemplates").dialog('open');
    }
    else {
        $("#dialogTemplates").dialog('close');
    }
}
exports.OnSuccessGetAanvraagTemplates = OnSuccessGetAanvraagTemplates;
function Template_OnClick(code) {
    Algemeen.CallWebServiceGetGenericData('GetAanvraagTemplate', "{'Id':'" + code + "'}", OnSuccessGetAanvraagTemplate);
}
exports.Template_OnClick = Template_OnClick;
function OnSuccessGetAanvraagTemplate(data, status) {
    Algemeen.CheckSessionTimeout(data);
    var Template = data.d;
    Aanvraag.fillFieldsFromAanvraagData(Template, true);
    SampleNature.SetSelectedValueSampleNature(Template.SampleNature);
    Country.SetSelectedValueCountry(Template.CountryOfOrigine, Country.cbCountryOfOrigine);
    Country.SetSelectedValueCountry(Template.CountryOfDestination, Country.cbCountryOfDestination);
    exports.cbProducer.SetSelectedText(Template.Producer);
    exports.cbInvoiceCustomer.SetSelectedValue(Template.InvoiceCustomer);
    exports.cbProcessing.SetSelectedValue(Template.Processing);
    exports.cbControlType.SetSelectedValue(Template.ControlType);
    exports.cbControlNumber.SetSelectedValue(Template.ControlNumber);
    exports.cbPriority.SetSelectedValue(Template.Priority);
    AanvraagStaal.cbBy.SetSelectedText(Template.By);
    AanvraagStaal.cbTransportMethod.SetSelectedValue(Template.TransportMethod);
    Methodes.fillMethodsProducts(Template.MethodsProducts);
    AanvraagReports.fillCommunicationMethod(Template.CommunicationMethods);
    $("#tabs").tabs("option", "disabled", []); //Onmiddelijke alle tabs beschikbaar bij template
    $('.btnQuickSave').show();
    Aanvraag.ValidateAllTabs();
}
function TemplateDelete_OnClick(code) {
    templateCodeToDelete = code;
    $dialogTemplateDelete.dialog('open');
}
exports.TemplateDelete_OnClick = TemplateDelete_OnClick;
function TemplateDelete(obj) {
    Algemeen.CallWebServiceGetGenericData('DeleteAanvraagTemplate', "{'Id':'" + templateCodeToDelete + "'}", OnSuccessDeleteAanvraagTemplate);
    $dialogTemplateDelete.dialog("close");
}
function OnSuccessDeleteAanvraagTemplate(data, status) {
    var result = data.d;
    Algemeen.CallWebServiceGetGeneric('GetAanvraagTemplates', OnSuccessGetAanvraagTemplates);
}
function btnTemplateClick() {
    $("#dialogTemplates").dialog("open");
}
